import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VouchersPrimeTableComponent } from './vouchers-prime-table.component';
import { TableModule } from 'primeng/table';
import { RoundButtonModule } from 'app/shared/round-button/round-button.module';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [VouchersPrimeTableComponent],
  imports: [
    TableModule,
    CommonModule,
    RoundButtonModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    FormsModule,
  ],
  exports: [VouchersPrimeTableComponent],
})
export class VouchersPrimeTableModule {}
